import PopupManager from "element-ui/lib/utils/popup/popup-manager";

// Vant 与 Element 的层级计数互不相通；从当前可见弹窗之上分配新层级。
export function nextPopupZIndex(minimum = 2000) {
  let zIndex = Math.max(minimum, PopupManager.zIndex);
  document
    .querySelectorAll(
      ".van-popup, .van-overlay, .el-dialog__wrapper, .v-modal, .el-message-box__wrapper",
    )
    .forEach((element) => {
      if (!element.getClientRects().length) return;
      const style = window.getComputedStyle(element);
      if (style.visibility === "hidden") return;
      zIndex = Math.max(zIndex, (Number.parseInt(style.zIndex, 10) || 0) + 1);
    });
  // 为弹窗和遮罩预留层级，后续 Element 子弹窗继续在其上方递增。
  PopupManager.zIndex = zIndex + 3;
  return zIndex;
}
